export type PlayerUrlFilters = {
  userId: string;
  username: string;
};

export function playerFiltersFromUrl(search: string): PlayerUrlFilters | null {
  const params = new URLSearchParams(search);
  const userId = params.get('userId') || '';
  const username = params.get('username') || '';
  if (!userId && !username) return null;
  return { userId, username };
}

export function hasPlayerFilter(filters: { userId?: string; username?: string }): boolean {
  return Boolean(filters.userId?.trim() || filters.username?.trim());
}
